export default class DealFilters {
  static filterPorfolioDeals = (items) => {
    return items?.filter(i => i.associatedProduct.structure_provider === 'Wealth Migrate');
  };

  static filterIndependentDeals = (items) => {
    return items?.filter(i => i.associatedProduct.structure_provider !== 'Wealth Migrate');
  };
}
